import {
	Component,
	Input,
	OnChanges,
	OnInit,
	SimpleChanges
} from '@angular/core';

import { IVbSource } from 'vbrick-player-src/IVbSource';
import { PlayerUserPreferencesService } from 'vbrick-player-src/shared/userPreference/PlayerUserPreference.Service';
import { VbBaseMenuComponent } from 'vbrick-player-src/shared/VbBaseMenu.Component';
import { VideogularComponent } from 'vbrick-player-src/videogular/Videogular.Component';

import { IDualPlaybackLayoutOption } from './IDualPlaybackLayoutOption';

import menuButtonStyles from 'vbrick-player-src/MenuButton.module.less';
import styles from './VbDualPlaybackLayoutMenuButton.module.less';

@Component({
	selector: 'vb-dual-playback-layout-menu-button',
	host: {
		'[class]': 'styles.root'
	},
	template: `
	`,
    standalone: false
})
export class VbDualPlaybackLayoutMenuButtonComponent extends VbBaseMenuComponent implements OnChanges, OnInit {
	@Input() public isSmallSizePlayer: boolean;
	@Input() public layoutOptions: IDualPlaybackLayoutOption[];
	@Input() public sources: IVbSource[];

	public readonly styles = { ...menuButtonStyles, ...styles };

	constructor(
		protected readonly PlayerUserPreferencesService: PlayerUserPreferencesService,
		public vgApi: VideogularComponent
	) {
		super();
	}

	public ngOnInit(): void {
		// set initial value to the first option
		this.resetSelection();
	}

	public ngOnChanges(changes: SimpleChanges): void {
		// reset the selection when the sources change
		if (changes.sources) {
			this.resetSelection();
		}
	}

	public layoutOptionsTrackByFunc(_index: number, layoutOption: IDualPlaybackLayoutOption): string {
		return layoutOption.id;
	}

	protected resetSelection(): void {
		if (this.layoutOptions?.length) {
			this.updateSelection(this.layoutOptions[0]);
		}
	}

	protected updateSelection(layoutOption: IDualPlaybackLayoutOption): void {
		this.vgApi.setDualPlaybackLayout(layoutOption);
	}
}
